import React from "react";
import { useInRouterContext, useNavigate } from "react-router-dom";
import { Button } from "../ui";
import { BILLING_PATH } from "../../access/subscription";

function RouterButton({ label }) {
  const navigate = useNavigate();
  return <Button type="button" size="sm" variant="primary" appearance="filled" onClick={() => navigate(BILLING_PATH)}>{label}</Button>;
}

function PlainButton({ label }) {
  return <Button type="button" size="sm" variant="primary" appearance="filled" onClick={() => window.location.assign(BILLING_PATH)}>{label}</Button>;
}

/** Opens the existing billing page (`/auth/billing`). */
export function BillingButton({ label }) {
  return useInRouterContext() ? <RouterButton label={label} /> : <PlainButton label={label} />;
}

export default BillingButton;
